module.exports = [{"value":"บ้านญาติ","text":"บ้านญาติ"},{"value":"หอพัก","text":"หอพัก"},{"value":"บ้านตนเอง","text":"บ้านตนเอง"},{"value":"บ้านเช่า","text":"บ้านเช่า"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/AddressType/addressTypeTH.json
// module id = PScK
// module chunks = 2